import React from 'react'
// components
import { LoaderWithOverlay } from 'components/UI/Loader'
import { CloseIcon } from 'components/UI/Icons'
// view components
import ObjectiveDetailsSection from 'components/Modals/PlanItems/Objective/MinimizedModal/components/DetailsSection'
import ActionDetailsSection from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection'
import KPIDetailsSection from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection'
// hocs
import withObjective from 'components/Modals/PlanItems/Objective/withObjective'
import withAction from 'components/Modals/PlanItems/Action/withAction'
import withKPI from 'components/Modals/PlanItems/KPI/withKPI'
// context
import { ActionContext, KPIContext, ObjectiveContext } from 'context/EntityContext'
// constants
import { Forms } from 'constants/index'
// views
import { FlexScrollbar, Header } from 'components/Modals/PlanItems/styles'
// types
import { LogEntityTypes } from 'types/graphql'

interface IPreviewProps {
  entity: { id: string }
  hideModal: () => void
}

const createPreview = (
  withEntity: (component: React.FC<any>) => React.FC<any>,
  EntityContext: React.Context<any>,
  DetailsSection: React.FC<any>,
  logEntityType: LogEntityTypes,
  form: string
) =>
  withEntity(({ hideModal }: IPreviewProps) => {
    const { entity, isLoading } = React.useContext(EntityContext)

    return (
      <>
        <Header>
          {!isLoading && (
            <>
              <span>{entity?.description}</span>
              <CloseIcon onClick={hideModal} />
            </>
          )}
        </Header>
        <LoaderWithOverlay isLoading={isLoading} />
        {!isLoading && entity && (
          <FlexScrollbar>
            <DetailsSection
              isReadOnly
              disableDrag
              form={form}
              hideModal={hideModal}
              entity={{ ...entity, entityType: logEntityType }}
            />
          </FlexScrollbar>
        )}
      </>
    )
  })

export const ObjectivePreview = createPreview(
  withObjective,
  ObjectiveContext,
  ObjectiveDetailsSection,
  LogEntityTypes.Objective,
  `${Forms.OBJECTIVE_DETAILS_FORM}_PREVIEW`
)

export const ActionPreview = createPreview(
  withAction,
  ActionContext,
  ActionDetailsSection,
  LogEntityTypes.Action,
  `${Forms.ACTION_DETAILS_FORM}_PREVIEW`
)

export const KPIPreview = createPreview(
  withKPI,
  KPIContext,
  KPIDetailsSection,
  LogEntityTypes.Kpi,
  `${Forms.KPI_DETAILS_FORM}_PREVIEW`
)
